import store from '@/store/store';
import {
  ioEDTransaccionality, ioEDHoldingTransaccionality
} from '@/febos/servicios/api/repositories.api';

export const getTransaccionality = async ({ commit }, payload) => {
  try {
    store.commit('Approvals/SET_LOADING', true);
    const response = await ioEDTransaccionality(payload);
    commit('SET_TRANSACCIONALITY', response.data.empresas);
    commit('SET_TRANSACTIONALITY_PAGINATION', response.data);
    return response.data;
  } finally {
    store.commit('Approvals/SET_LOADING', false);
  }
};

export const getHoldingTransaccionality = async ({ commit }, payload) => {
  try {
    store.commit('Approvals/SET_LOADING', true);
    const response = await ioEDHoldingTransaccionality(payload);
    commit('SET_HOLDING_TRANSACCIONALITY', response.data.empresas[0]);
  } finally {
    store.commit('Approvals/SET_LOADING', false);
  }
};
